import { observable, action, makeObservable } from 'mobx';

class DspStore {
  constructor(api) {
    makeObservable(this, {
      dspSearchResult: observable,
      couriers: observable,
      search: action,
      listAll: action,
    });

    this.baseUrl = '';
    this.api = api;
  }

  dspSearchResult = [];
  couriers = [];

  search(keyword) {
    const queryParams = {ignore_types: ["LINEHAUL"]};
    this.api.get(`/couriers/advanced-search/${keyword}`, queryParams).then(
      action((response) => {
        if (response.status === 200) {
          this.dspSearchResult = response.data;
        }
      }),
    );
  }

  listAll(onAssignScreen = false) {
    const queryParams = {size: 1000, ignore_types: ["LINEHAUL"]};
    this.api.get(`/couriers/search`, queryParams).then(
      action((response) => {
        if (response.status === 200) {
          this.couriers = response.data;
          if (onAssignScreen) {
            this.dspSearchResult = response.data.couriers;
          }
        }
      }),
    );
  }
}

export default DspStore;
